import {Grid, TextField} from '@mui/material';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import {digitsFaToEn} from 'persian-tools2';
import {useState} from 'react';

import phoneShare from 'assets/img/phoneShare.svg';
import {validateSharePhoneNumber} from 'helpers/Functions';
import Message from 'assets/img/messages-ios.svg';
import SmsSent from './SmsSent';

const ShareModalStyle = {
  sendWithSMS: {
    textAlign: 'center',
    fontFamily: 'dana-bold',
    fontSize: '14px',
    color: '#753CBE',
    display: 'flex !imprtant',
    alignItems: 'center !important',
    justifyContent: 'center !imprtant',
  },
  SMSBtn: {
    width: '232px !important',
    display: 'flex !imprtant',
    alignItems: 'center !important',
    justifyContent: 'center !imprtant',
    textAlign: 'center',
    background: ' #F5F5F5',
    border: '1px solid #FFFFFF',
    boxShadow: '4px 4px 15px rgba(172, 172, 172, 0.5), -4px -4px 15px #FFFFFF',
    borderRadius: '16px',
    height: '48px',
    fontFamily: 'dana-bold',
  },
  noPhoneNum: {
    fontFamily: 'dana-bold',
    fontSize: '14px',
    color: '#6F4D9F',
  },
  userName: {
    fontWeight: '400',
    fontSize: '14px',
    color: '#6F4D9F',
  },
  errorText: {
    color: '#d81d5d',
    fontWeight: 'bold',
    fontSize: '12px',
    position: 'absolute',
    right: '15px',
    top: '-40px',
  },
  closeIcon: {
    color: '#707070',
    fontSize: '1rem',
    position: 'absolute',
    top: '23px',
    right: '23px',
    cursor: 'pointer',
  },
};

const SendToOther = (props) => {
  const {sendSMSHandler, handleCloseModal, delivered} = props;
  const [phoneNumber, setPhoneNumber] = useState('');
  const [showValidateText, setShowValidateText] = useState(false);
  const validatePhoneNumber = validateSharePhoneNumber(phoneNumber);
  const showError = () => {
    if (validatePhoneNumber) {
      setShowValidateText(true);
    }
  };

  // input Border color
  const inputBorderColor =
    validatePhoneNumber && showValidateText
      ? '1px solid #d81d5d'
      : '1px solid #FFFFFF';

  const inputBorderFocused =
    validatePhoneNumber && showValidateText
      ? '1px solid #d81d5d'
      : '1px solid #707070';

  // textField style
  const inputStyle = {
    width: '267px',
    margin: '17px auto 50px',
    color: 'red',

    '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
      display: 'none',
    },
    '& input[type=number]': {
      MozAppearance: 'textfield',
    },
    '& .MuiOutlinedInput-root:hover': {
      '& > fieldset': {
        border: inputBorderColor,
      },
    },
    '& .MuiOutlinedInput-root': {
      background: '#F5F5F5',
      fontWeight: '400',
      color: '#707070',
      '& > fieldset': {
        border: inputBorderColor,
        boxShadow:
          '8px 8px 20px rgba(172, 172, 172, 0.5), -8px -8px 20px #FFFFFF',

        fontWeight: 'bold',
      },
      '& fieldset': {
        borderRadius: '16px',
      },
      '&.Mui-focused fieldset': {
        border: inputBorderFocused,
        borderRadius: '16px',
      },
    },
    '& label.Mui-focused': {
      color: '#707070',
      paddingLeft: '0 !important',
    },
    '& label': {
      textAlign: 'center',
      paddingLeft: phoneNumber.length === 0 && '70px',
      paddingTop: '2.5px',
    },
  };

  return (
    <div>
      {!delivered ? (
        <Grid container>
          <CloseIcon
            style={ShareModalStyle.closeIcon}
            onClick={() => handleCloseModal()}
          />
          <Grid item xs={12}>
            <p style={{textAlign: 'center'}}>
              <span style={ShareModalStyle.noPhoneNum}>
                جهت ارسال پیامک به دیگران، شماره موبایل موردنظر خود را وارد
                کنید:
              </span>
            </p>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              mt: '20px',
            }}>
            <div style={{position: 'relative'}}>
              <TextField
                dir='ltr'
                value={phoneNumber}
                onChange={(e) => {
                  e.target.value.length < 12 && setPhoneNumber(e.target.value);
                }}
                id='outlined-number'
                label='شماره تماس'
                type='number'
                sx={inputStyle}
              />
              <img
                src={phoneShare}
                alt=''
                style={{position: 'absolute', top: '37px', right: '20px'}}
              />
            </div>
          </Grid>
          <Grid item xs={12} position='relative'>
            {showValidateText && (
              <p dit='ltr' style={ShareModalStyle.errorText}>
                {validatePhoneNumber}
              </p>
            )}
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              margin: '0 0 10px',
            }}>
            <Button
              sx={ShareModalStyle.SMSBtn}
              onClick={() => {
                showError();
                sendSMSHandler(phoneNumber && digitsFaToEn(phoneNumber));
              }}>
              <img src={Message} alt='' />
              <span style={{marginRight: '10px'}}>ارسال گزارش با SMS</span>
            </Button>
          </Grid>
        </Grid>
      ) : (
        <SmsSent
          handleCloseModal={handleCloseModal}
          phoneNumber={phoneNumber}
        />
      )}
    </div>
  );
};

export default SendToOther;
